import React from 'react';
import { HiChevronRight } from 'react-icons/hi';
import './ios-components.css';

/**
 * List Item estilo iOS Settings
 * Props:
 * - icon: Componente de ícone (opcional)
 * - title: string (obrigatório)
 * - subtitle: string (opcional)
 * - onClick: function
 * - href: string (se for link)
 * - chevron: boolean (mostra seta, default: true se onClick/href)
 * - accessory: ReactNode (elemento à direita, ex: switch, badge)
 * - destructive: boolean (estilo vermelho para ações destrutivas)
 */
function IOSListItem({
  icon: Icon,
  title,
  subtitle,
  onClick,
  href,
  chevron,
  accessory,
  destructive = false,
  children,
  ...props
}) {
  const showChevron = chevron !== undefined ? chevron : !!(onClick || href);
  const Component = href ? 'a' : onClick ? 'button' : 'div';
  
  const className = `
    ios-list-item
    ${onClick || href ? 'ios-list-item--clickable' : ''}
    ${destructive ? 'ios-list-item--destructive' : ''}
  `;

  const content = (
    <>
      {Icon && (
        <div className="ios-list-item__icon">
          <Icon size={22} />
        </div>
      )}
      
      <div className="ios-list-item__content">
        <div className="ios-list-item__title">{title}</div>
        {subtitle && (
          <div className="ios-list-item__subtitle">{subtitle}</div>
        )}
        {children}
      </div>
      
      <div className="ios-list-item__accessory">
        {accessory}
        {showChevron && !accessory && (
          <HiChevronRight className="ios-list-item__chevron" size={20} />
        )}
      </div>
    </>
  );

  if (href) {
    return (
      <a href={href} className={className} {...props}>
        {content}
      </a>
    );
  }

  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={className} {...props}>
        {content}
      </button>
    );
  }

  return <div className={className} {...props}>{content}</div>;
}

/**
 * Grupo de list items estilo iOS
 */
export function IOSListGroup({ children, title, footer }) {
  return (
    <div className="ios-list-group">
      {title && <div className="ios-list-group__title">{title}</div>}
      <div className="ios-list-group__items">{children}</div>
      {footer && <div className="ios-list-group__footer">{footer}</div>}
    </div>
  );
}

export default IOSListItem;
